import { useTranslation } from "react-i18next";
import { TimeSelect } from "../../../types";
import React, { useEffect, useState } from "react";
import { getLocale } from "../../../utils";
import { useAppSelector } from "../../../app/hooks";
import {
  afternoonLabel,
  anyTimeLabel,
  eveningLabel,
  morningLabel,
} from "./utils";

interface TimeInputProps {
  id: string;
  disabled: boolean;
  value: TimeSelect;
  label: string;
  onSelect: (TimeSelect) => void;
  noTime: boolean;
}

function TimeSelectInput({
  id,
  disabled,
  value,
  label,
  onSelect,
  noTime,
}: TimeInputProps) {
  const { t, i18n } = useTranslation();
  const timeFormat = useAppSelector(
    (state) => state.config.components.timeFormat
  );
  const [locale, setLocale] = useState<Locale>();

  useEffect(() => {
    const newLocale = getLocale(i18n.language);
    setLocale(newLocale);
  }, [i18n.language]);

  const onChange = (e) => {
    onSelect(e.target.value);
  };

  return (
    <div className="field">
      <label className="label" htmlFor={id}>
        {label}
      </label>
      <div className="control">
        <div className="select is-fullwidth">
          <select id={id} value={value} onChange={onChange} disabled={disabled}>
            <option value="ANY_TIME">
              {t("ANY_TIME")} {!noTime ? anyTimeLabel(locale, timeFormat) : ""}
            </option>
            <option value="MORNING">
              {t("MORNING")} {!noTime ? morningLabel(locale, timeFormat) : ""}
            </option>
            <option value="AFTERNOON">
              {t("AFTERNOON")} {!noTime ? afternoonLabel(locale, timeFormat) : ""}
            </option>
            <option value="EVENING">
              {t("EVENING")} {!noTime ? eveningLabel(locale, timeFormat) : ""}
            </option>
          </select>
        </div>
      </div>
    </div>
  );
}

export default TimeSelectInput;
